package com.ijoin

interface Platform {
    val name: String
    val isMobile: Boolean
        get() = name.contains("Android", ignoreCase = true) ||
                name.contains("iOS", ignoreCase = true) ||
                name.contains("iPadOS", ignoreCase = true)

    val isWeb: Boolean
        get() = name.contains("JS", ignoreCase = true) ||
                name.contains("Wasm", ignoreCase = true) ||
                name.contains("Web", ignoreCase = true)
}

expect fun getPlatform(): Platform
